import { getSelectorRoot } from 'utils/selectors';

const getBetSlip = getSelectorRoot('betSlip');

const getOpenBetsData = getBetSlip('openBetsData');
const getOpenBetsCount = getBetSlip('openBetsCount');
const getOpenBetsLoading = getBetSlip('openBetsLoading');
const getUpdateOpenBetsTrigger = getBetSlip('updateOpenBetsTrigger');
const getOpenBetsCountAfterCashout = getBetSlip('openBetsCountAfterCashout');

export {
  getOpenBetsData,
  getOpenBetsCount,
  getOpenBetsLoading,
  getUpdateOpenBetsTrigger,
  getOpenBetsCountAfterCashout
};
